import { ISelectFieldOption } from "@/app/fields/types";
import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Checkbox,
  Stack,
} from "@chakra-ui/react";

export function SelectFieldFilterGroup({
  options,
  values,
  setValues,
  label,
  isDisabled,
}: {
  options: ISelectFieldOption[];
  values: string[];
  setValues: (v: string[]) => void;
  label: string;
  isDisabled: boolean;
}) {
  const optionValues = options.map(({ value }) => value);

  const allChecked =
    optionValues.filter((value) => !values.includes(value)).length === 0;

  const anyChecked =
    !allChecked &&
    optionValues.filter((value) => values.includes(value)).length > 0;

  return (
    <AccordionItem>
      <AccordionButton data-cy={`group-subfilter-${label}`}>
        <Box as="span" flex="1" textAlign="left">
          <Checkbox
            isDisabled={isDisabled}
            data-cy={`group-checkbox-${label}`}
            className="focus:outline-none"
            isChecked={allChecked}
            isIndeterminate={anyChecked}
            onChange={() => {
              if (allChecked) {
                // remove all if all
                setValues(values.filter((v) => !optionValues.includes(v)));
              } else {
                // add all if none or some
                setValues([
                  ...values.filter((v) => !optionValues.includes(v)),
                  ...optionValues,
                ]);
              }
            }}
          >
            {options.length > 1 ? label : options[0].label}
          </Checkbox>
        </Box>
        {options.length > 1 && (
          <AccordionIcon data-cy={`accordion-icon-${label}`} />
        )}
      </AccordionButton>
      {options.length > 1 ? (
        <AccordionPanel pl={6} data-cy={`options-panel-${label}`}>
          <Stack spacing={2}>
            {options.map((option) => (
              <Checkbox
                isDisabled={isDisabled}
                key={option.value}
                isChecked={values.includes(option.value)}
                onChange={() =>
                  setValues(
                    values.includes(option.value)
                      ? values.filter((v) => v !== option.value)
                      : [...values, option.value]
                  )
                }
              >
                {option.label}
              </Checkbox>
            ))}
          </Stack>
        </AccordionPanel>
      ) : (
        <AccordionPanel
          data-cy={`hidden-options-panel-${label}`}
          p={0}
          className="h-0"
        />
      )}
    </AccordionItem>
  );
}
